import Link from 'next/link'
import { Card, CardBody } from 'reactstrap'
import BreadcrumbBar from '~/components/shared/BreadcrumbBar'

function SmsAuth () {
  const breadcrumbs = [
    { name: 'Login Help', href: '/login-help' },
    { name: 'SMS Authentication', href: '/login-help/sms-auth' }
  ]

  return (
    <>
      <BreadcrumbBar breadcrumbs={breadcrumbs} />

      <h2 className='pb-2'>SMS Authentication</h2>

      <Card>
        <CardBody>
          <p>
            SMS Authentication allows for authentication via mobile text messaging (SMS).
          </p>
          <hr />
          <h2>Setting up SMS Authentication</h2>
          <p>
            Login to <Link href='/'>mySCPHealth.com</Link>.
            When prompted to set up multifactor authentication, select <b>Setup</b> under the SMS Authentication option.
          </p>
          <p>
            If you have already logged in and setup an MFA method, you will need to <Link href='/login-help/change-auth-methods'><a>Change Authentication Methods</a></Link> and continue the setup.
          </p>
          <p>
            The next screen will ask you to enter your mobile number.
          </p>
          <img className='mb-4' src='/static/img/sms-auth.png' alt='sms authentication' />
          <p>
            Select your country, then enter your mobile number and press <b>Send Code</b>.
            You should receive a text message containing a verification code.
            Enter the code into the verification box and press <b>Verify</b>.
          </p>
          <p>
            The setup page should now show SMS Authentication under <b>Enrolled Factors</b>.
            Click <b>Finish</b> to complete the process.
          </p>
        </CardBody>
      </Card>
    </>
  )
}

SmsAuth.publicAccess = true

SmsAuth.getInitialProps = () => ({
  title: 'SMS Authentication'
})

export default SmsAuth
